export const wait = ms => new Promise(res => setTimeout(res, ms));

export const mixColors = (...colors) => {
    let base = [0, 0, 0, 0];
    let mix;
    let added;

    while (added = colors.shift()) {
        if (typeof added[3] === 'undefined') {
            added[3] = 1;
        }
        // check if both alpha channels exist.
        if (base[3] && added[3]) {
            mix = [0, 0, 0, 0];
            // alpha
            mix[3] = 1 - (1 - added[3]) * (1 - base[3]);
            // red
            mix[0] = Math.round((added[0] * added[3] / mix[3]) + (base[0] * base[3] * (1 - added[3]) / mix[3]));
            // green
            mix[1] = Math.round((added[1] * added[3] / mix[3]) + (base[1] * base[3] * (1 - added[3]) / mix[3]));
            // blue
            mix[2] = Math.round((added[2] * added[3] / mix[3]) + (base[2] * base[3] * (1 - added[3]) / mix[3]));

        } else if (added) {
            mix = added;
        } else {
            mix = base;
        }
        base = mix;
    }

    return mix;
}

export const sortBy = (array, match) => {
    const final = [...array];
    const max = final.length;

    return final.sort((a, b) => {
        const ia = match.indexOf(a);
        const ib = match.indexOf(b);

        return (ia === -1 ? max : ia) - (ib === -1 ? max : ib);
    });
}